import type { CreateProjectGroupDto } from '~/src/shared/types/generated'
import { monitoringProjectGroupRepository } from '~/src/shared/api/repositories/monitoring/project-group/repository'
import { useMutation } from '~/src/shared/composables/query/useMutations'
import { useQuery } from '~/src/shared/composables/query/useQuery'
import { useUserStore } from '~/src/shared/pinia/user/useUserStore'

export function useGetMonitoringProjectGroups() {
    const { $ofetch } = useNuxtApp()
    const { getAllProjectGroups } = monitoringProjectGroupRepository($ofetch)
    const userStore = useUserStore()

    return useQuery({
        queryKey: ['monitoring-project-groups'],
        queryFn: () => getAllProjectGroups(),
        enabled: userStore.isUserAuth
    })
}

export function useCreateMonitoringProjectGroup() {
    const { $ofetch } = useNuxtApp()
    const { createProjectGroup } = monitoringProjectGroupRepository($ofetch)
    const userStore = useUserStore()

    return useMutation({
        mutationFn: (data: CreateProjectGroupDto) => createProjectGroup(data),
        enabled: userStore.isUserAuth
    })
}
